(ns dre.widgets.dates.views
  (:require
   [dre.components.widget.views :as widget-base]
   [dre.components.widget.views.common :refer [no-result title-with-filter]]
   [dre.i18n.views :refer [tr]]
   [dre.widgets.dates.events :as events]
   [dre.components.widget.events :as wevents]
   [dre.pages.search.events :as search-events]
   [dre.components.timeline :refer [timeline]]
   [re-frame.core :as rf]))

(defn widget-content
  [_id _data _selected-type _extent-selection]
  (fn [id data selected-type extent-selection]
    (let [extent-change-fn (fn [extent]
                             (if extent
                               (rf/dispatch [::search-events/reset-widget-filter (str id selected-type) (events/->pill selected-type extent)])
                               (rf/dispatch [::search-events/reset-widget-filter (str id selected-type) nil]))
                             (rf/dispatch [::events/set-extent-selection selected-type extent]))]
      [:<>
       (if (not (seq (:years data)))
         [no-result true]
         [timeline (:years data) extent-change-fn extent-selection])])))

(defn view
  [id title]
  (let [default-type :published
        selected-type @(rf/subscribe [::wevents/selection id ::type])
        selected-type (if (not selected-type)
                        default-type
                        selected-type)
        status @(rf/subscribe [::events/status selected-type])
        done? @(rf/subscribe [::events/done? selected-type])
        data @(rf/subscribe [::events/data selected-type])
        extent-selection @(rf/subscribe [::events/extent-selection selected-type])
        loading? (= :loading status)
        c-header (when (and (not done?) (seq data))
                   [:div [tr " Partial results shown due to network problem, try refreshing page"]])]
    [widget-base/view
     id
     [title-with-filter title (str id selected-type)]
     [widget-content id data selected-type extent-selection]
     c-header
     nil
     {:csv-event [::events/export selected-type]
      :export-image? true
      :selections
      [{:id ::type
        :type :dropdown
        :default-option default-type
        :options [{:id :published :label [tr "Published date"]}
                  {:id :changed :label [tr "Changed date"]}]}]}
     {:loading? loading?}]))